import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import QuotePage from "../pages/quote/page";
import AreasPage from "../pages/areas/page";
import ChelmsfordPage from "../pages/areas/chelmsford/page";
import ColchesterPage from "../pages/areas/colchester/page";
import BasildonPage from "../pages/areas/basildon/page";
import SouthendPage from "../pages/areas/southend/page";
import HarlowPage from "../pages/areas/harlow/page";
import BraintreePage from "../pages/areas/braintree/page";
import BrentwoodPage from "../pages/areas/brentwood/page";
import GraysPage from "../pages/areas/grays/page";
import ClactonPage from "../pages/areas/clacton/page";
import RayleighPage from "../pages/areas/rayleigh/page";
import WickfordPage from "../pages/areas/wickford/page";
import BillericayPage from "../pages/areas/billericay/page";
import WithamPage from "../pages/areas/witham/page";
import LoughtonPage from "../pages/areas/loughton/page";
import MaldonPage from "../pages/areas/maldon/page";
import SaffronWaldenPage from "../pages/areas/saffron-walden/page";
import CanveyIslandPage from "../pages/areas/canvey-island/page";
import EppingPage from "../pages/areas/epping/page";
import RochfordPage from "../pages/areas/rochford/page";
import StanstedPage from "../pages/areas/stansted/page";
import TilburyPage from "../pages/areas/tilbury/page";
import WalthamAbbeyPage from "../pages/areas/waltham-abbey/page";
import LeighOnSeaPage from "../pages/areas/leigh-on-sea/page";
import ChigwellPage from "../pages/areas/chigwell/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/quote",
    element: <QuotePage />,
  },
  {
    path: "/areas",
    element: <AreasPage />,
  },
  {
    path: "/areas/chelmsford",
    element: <ChelmsfordPage />,
  },
  {
    path: "/areas/colchester",
    element: <ColchesterPage />,
  },
  {
    path: "/areas/basildon",
    element: <BasildonPage />,
  },
  {
    path: "/areas/southend-on-sea",
    element: <SouthendPage />,
  },
  {
    path: "/areas/harlow",
    element: <HarlowPage />,
  },
  {
    path: "/areas/braintree",
    element: <BraintreePage />,
  },
  {
    path: "/areas/brentwood",
    element: <BrentwoodPage />,
  },
  {
    path: "/areas/grays",
    element: <GraysPage />,
  },
  {
    path: "/areas/clacton-on-sea",
    element: <ClactonPage />,
  },
  {
    path: "/areas/rayleigh",
    element: <RayleighPage />,
  },
  {
    path: "/areas/wickford",
    element: <WickfordPage />,
  },
  {
    path: "/areas/billericay",
    element: <BillericayPage />,
  },
  {
    path: "/areas/witham",
    element: <WithamPage />,
  },
  {
    path: "/areas/loughton",
    element: <LoughtonPage />,
  },
  {
    path: "/areas/maldon",
    element: <MaldonPage />,
  },
  {
    path: "/areas/saffron-walden",
    element: <SaffronWaldenPage />,
  },
  {
    path: "/areas/canvey-island",
    element: <CanveyIslandPage />,
  },
  {
    path: "/areas/epping",
    element: <EppingPage />,
  },
  {
    path: "/areas/rochford",
    element: <RochfordPage />,
  },
  {
    path: "/areas/stansted",
    element: <StanstedPage />,
  },
  {
    path: "/areas/tilbury",
    element: <TilburyPage />,
  },
  {
    path: "/areas/waltham-abbey",
    element: <WalthamAbbeyPage />,
  },
  {
    path: "/areas/leigh-on-sea",
    element: <LeighOnSeaPage />,
  },
  {
    path: "/areas/chigwell",
    element: <ChigwellPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
